import React from 'react';

const LoadingSpinner = () => (
    <div className="loading-spinner">
        <img src="/img/uranum_white.png" alt="Loading" className="loading-spinner-logo" />
    </div>
);

export default LoadingSpinner;
